import { useEffect, useState } from 'react';
import { usePrevious } from 'app/infrastructure/hooks';
import { Configuration } from 'app/components/metro-line/types';
import { SavedReportsValidation } from 'app/area/shared/saved-reports/types-store';
import { DefaultFilterValidation } from 'app/area/shared/default-filters/types-store';
import { SavedReportDashboard } from '../../common/types-store';
import { DashboardItemValidation } from '../types-store';
import { DashboardSectionType } from './types';

export const useInvalidSection = (
  configuration: Configuration<DashboardSectionType>[],
  validation: DashboardItemValidation,
  savedReportsValidation: SavedReportsValidation<SavedReportDashboard>,
  filterValidation: { [domainId: number]: DefaultFilterValidation }
): [Configuration<DashboardSectionType>, React.Dispatch<React.SetStateAction<Configuration<DashboardSectionType>>>] => {

  const [invalidSection, updateInvalidSection] = useState(configuration.find(configurationSection => !configurationSection.isValid));
  const previousValidation = usePrevious(validation);
  const previousSavedReportsValidation = usePrevious(savedReportsValidation);
  const previousFilterValidation = usePrevious(filterValidation);

  useEffect(() => {
    if (invalidSection === undefined &&
      (validation !== previousValidation ||
        savedReportsValidation !== previousSavedReportsValidation ||
        filterValidation !== previousFilterValidation)
    ) {
      updateInvalidSection(configuration.find(configurationSection => !configurationSection.isValid));
    }
  }, [configuration, validation, savedReportsValidation, filterValidation]);

  return [invalidSection, updateInvalidSection];
};
